import { Link } from "react-router-dom";
import { calculateAge } from "../utils/utils";

export default function profileCard({ profile }) {
  return (
    <>
    {/* <div className="col-sm-6 col-xl-4" key={profile._id}>
      <div className="profile-card">
        <span className="card-id-badge">{profile.profile_id}</span>
        <div className="card-img-wrap">
          <img src="https://images.unsplash.com/photo-1614289371518-722f2615943d?w=400&q=80" alt="{profile.name}" loading="lazy" />
        </div>
        <div className="card-body-custom">
          <div className="card-name">{profile.name}</div>
          <div className="card-meta">
            <span><i className="fas fa-birthday-cake" /> {calculateAge(profile.dob)} yrs</span>
            <span><i className="fas fa-map-marker-alt" /> {profile.pob}</span>
            <span><i className="fas fa-graduation-cap" /> {profile.education}</span>
          </div>
          <div className="card-actions">
            <button className="btn-view">View Profile</button>
            <button className="btn-shortlist"><i className="fas fa-heart" /></button>
          </div>
        </div>
      </div>
    </div> */}
    
    <div className="col-md-3 mb-3" key={profile._id}>
        <Link
          to={`${process.env.PUBLIC_URL}/profile/${profile._id}`}
          className="text-decoration-none text-dark"
        >
          <div className="profile-card">
            {profile.photos && profile.photos.length > 0 ? (
              <img
                src={`${process.env.REACT_APP_SERVER_DOMAIN}${profile.photos[0].photo_path}`}
                alt={profile.name}
                className="card-img-top"
                style={{ height: "250px", objectFit: "cover" }} />
            ) : (
              // <div
              //   className="bg-light d-flex align-items-center justify-content-center"
              //   style={{ height: "200px" }}
              // >
              //   <span>No Photo</span>
              // </div>
              <img
                src={process.env.PUBLIC_URL + `/${profile.gender}.png`}
                alt={profile.name}
                className="card-img-top"
                style={{ height: "250px", objectFit: "cover", objectPosition: "0px -10px" }} />
            )}
            <span className="card-id-badge">{profile.profile_id}</span>
            <div className="card-body-custom">
              <h5 className="card-name">{profile.name}</h5>
              <p className="card-text">
                <strong>Age:</strong> {calculateAge(profile.dob)} <br />
                <strong>Job:</strong> {profile.jobType} <br />
                <strong>Salary:</strong> ₹{profile.salary} LPA <br />
                <strong>Working Place:</strong> {profile.workPlace} <br />
              </p>
              <div className="card-actions">
            <button className="btn-view">View Profile</button>
            {/* <button className="btn-shortlist"><i className="fas fa-heart" /></button> */}
          </div>
            </div>
            
          </div>
        </Link>
      </div></>
  );
}
